module.exports = __webpack_public_path__ + "img/button_home_off.17e538fa.png";